import { useEffect } from 'react'
import { isEmpty } from '../../../../utils/stringUtils'
import { ActivationObject } from '../../../providers/ActivationObjectProvider/types'
import { DefaultValue } from '../constants'
import { Step4FormConditionsProps, Step4FormProps } from '../types'

const useStep4FormConditions = (form: Step4FormProps['form'], activationObject?: ActivationObject): Step4FormConditionsProps => {
    const appMyJablotronEmail = form.watch('appMyJablotronEmail')
    const personContacts = form.watch('personContacts')
    // clear appEmail if not exists in the list of contact person emails
    useEffect(() => {
        if (!isEmpty(appMyJablotronEmail) && personContacts && !personContacts.some((x) => x.email === appMyJablotronEmail))
            form.setValue('appMyJablotronEmail', DefaultValue.appMyJablotronEmail)
    }, [appMyJablotronEmail, personContacts, form])

    return {
        canEditcanEditAppMyJablotronEmail: activationObject?.canEditAppMyJablotronEmail ?? false,
    }
}

export default useStep4FormConditions
